import SampleReportView from "@/components/samples/SampleReportView";
import { POWERFLEX_REPORT } from "@/data/sample-reports";

const PowerflexSample = () => <SampleReportView report={POWERFLEX_REPORT} />;

export default PowerflexSample;
